<template>
  <div class="dict-content">
    <div class="searchDiv">
      <div class="queryConditionDiv">
        <a-input v-model="searchModel.description" class="marginRight_12 searchColInput" placeholder="定时任务描述"></a-input>
        <a-range-picker
          :showToday="false"
          format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['执行时间','执行时间']"
          v-model="searchModel.executionTime"
          class="marginRight_12 searchColInput"
          show-time
        />
        <a-select
          :allowClear="true"
          v-model="searchModel.status"
          placeholder="执行状态"
          class="marginRight_12 searchColInput"
        >
          <a-select-option v-for="(item, index) in statusList" :value="item.value" :key="index">
            {{ item.label }}
          </a-select-option>
        </a-select>
        <a-button class="marginRight_12" type="primary" @click="search()">查询</a-button>
        <a-button @click="reset()">重置</a-button>
      </div>
    </div>
    <a-table
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
      :rowKey="(record) => record.id"
      :scroll="{ y: tableHeight }"
      class="listTable"
      @change="handleTableChange"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:" @click="handleView(record)"> 查看 </a>
      </template>
    </a-table>
    <view-modules ref="viewModules"></view-modules>
  </div>
</template>

<script>
import viewModules from '@/views/timingTask/modules/timingTaskLog/modules/viewModules.vue'
import { timedTaskLogs } from '@/api/timingTask'

export default {
  name: 'TimingTaskTable',
  components: { viewModules },
  data () {
    return {
      // 搜索条件
      searchModel: {
        description: '',
        executionTime: [],
        status: undefined
      },
      statusList: [
        {
          label: '成功',
          value: 1
        },
        {
          label: '失败',
          value: 2
        }
      ],
      // 表格
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            width: 70
          },
          {
            title: '定时任务描述',
            dataIndex: 'description'
          },
          {
            title: '执行时间',
            dataIndex: 'executionTime'
          },
          {
            title: '执行状态',
            dataIndex: 'status',
            customRender: (text, record, index) => {
              return record.status === 1 ? <span>成功</span> : <span style="color: red">失败</span>
            }
          },
          {
            title: '日志数据',
            dataIndex: 'content',
            ellipsis: true
          },
          {
            title: '操作',
            width: 200,
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      tableHeight: 'calc(100vh - 223px)'
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    // 获取表格数据
    getTableData () {
      const params = {
        description: this.searchModel.description,
        executionTime: this.searchModel.executionTime.length > 0 ? this.searchModel.executionTime[0].format('YYYY-MM-DD HH:mm:ss') : '',
        executionTimeEnd: this.searchModel.executionTime.length > 0 ? this.searchModel.executionTime[1].format('YYYY-MM-DD HH:mm:ss') : '',
        status: this.searchModel.status ? this.searchModel.status : '',
        ...this.tableData.pagination
      }
      timedTaskLogs(params)
        .then((res) => {
          if (res.status === 0) {
            this.tableData.data = res.data.list
            this.tableData.pagination.total = res.data.total
          } else {
            this.$message.error(res.info.message)
          }
        })
        .catch((err) => {
        })
    },
    // 切换页码
    handleTableChange (pagination) {
      this.tableData.pagination.pageNum = pagination.current
      this.tableData.pagination.pageSize = pagination.pageSize
      this.getTableData()
    },
    // 搜索
    search () {
      this.getTableData()
    },
    // 重置
    reset () {
      this.searchModel = {
        description: '',
        executionTime: '',
        status: undefined
      }
      this.getTableData()
    },
    // 打开编辑弹窗
    handleView (record) {
      this.$refs.viewModules.setTitle('查看定时任务日志')
      this.$refs.viewModules.setModel(record)
      this.$refs.viewModules.open(true)
    }
  }
}
</script>

<style lang="less" scoped>
.dict-content {
  overflow-y: hidden;
  background-color: #ffffff;
  height: 100%;
}
.searchDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .searchColInput {
    width: 200px;
  }
}
.marginRight_12 {
  margin-right: 12px;
}

/deep/.listTable {
  height: calc(100% - 50px);
  > .ant-spin-nested-loading {
    height: 100%;
    > .ant-spin-container {
      height: calc(100% - 50px);
      .ant-table {
        height: calc(100% - 64px);
        .ant-table-content {
          height: 100%;
          .ant-table-scroll {
            height: 100%;
            .ant-table-body {
              height: calc(100% - 40px);
            }
          }
        }
      }
      .ant-table-placeholder {
        position: absolute;
        background: none;
        border-top: none;
        border-bottom: none;
        border-radius: 0 0 4px 4px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 100px;
        .ant-empty-normal {
          margin: 0 !important;
        }
      }
    }
  }
}
/deep/.ant-form-item {
  display: flex;
}
</style>
